import React, { FC } from 'react';
import styled from './RemoveColumnDataModal.module.css';
import Modal from '../Modal';
import Button from '../../Button/Button';
import { useTranslation } from 'react-i18next';

interface Props {
    columnName: string;
    onCancel: () => void;
    onConfirm: () => void;
}

const RemoveColumnDataModal: FC<Props> = ({ columnName, onCancel, onConfirm }) => {
    const { t } = useTranslation();
    return (
        <Modal title={t('removeCustomColumnModalTitle')} subtitle={t('removeCustomColumnModalSubTitle', { columnName })}>
            <div className={styled.Options}>
                <Button variant="Primary" onClick={onCancel}>
                    {t('buttonCancel')}
                </Button>
                <Button variant="Outline" onClick={onConfirm}>
                    OK
                </Button>
            </div>
        </Modal>
    );
};

export default RemoveColumnDataModal;
